// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/swot/swot.component.css
// module id = 734
// module chunks = 0